import React from "react";
import { Routes, Route } from "react-router-dom";
import config from "../../config";

import { AltAsset, AuditAsset, Summary } from "./components";

export const routePrefix = `${config.paths.auth}/${config.paths.audits}`;

export default () => (
    <Routes>
        <Route index path="/" element={<Summary />}></Route>
        <Route
            index
            path="assets/:auditAssetId"
            element={<AuditAsset />}
        ></Route>
        <Route
            index
            path="alt-assets/:altAssetId"
            element={<AltAsset />}
        ></Route>
    </Routes>
);
